<template>
  <div>
    <vs-alert title="Informasi" class="my-5 mb-5" color="warning">
      Data yang tersaji pada halaman statistik ini berasal dari data perizinan / non perizinan yang diproses secara digital / elektronik melalui
      <strong> <a href="https://app.laperon.badungkab.go.id">Sistem Informasi LAPERON (Layanan Perizinan Online) Kabupaten Badung.</a></strong>
    </vs-alert>
    <PermohonanRecap />
    <PermohonanGraph :yearData="yearData" />
    <IzinTerbitGraph :yearData="yearData" />
    <PermohonanRejectGraph :yearData="yearData" />
    <div class="vx-row">
      <div class="w-full md:w-1/3 vx-col">
        <RatingBidang />
      </div>
      <div class="w-full md:w-2/3 vx-col">
        <RatingTerbaru />
      </div>
    </div>
    <div class="vx-row">
      <div class="w-full vx-col">
        <DisposisiTerbaru />
      </div>
    </div>
  </div>
</template>

<script>
import PermohonanRecap from './components/PermohonanRecap.vue'
import IzinTerbitGraph from './components/IzinTerbitGraph.vue'
import PermohonanGraph from './components/PermohonanGraph.vue'
import PermohonanRejectGraph from './components/PermohonanRejectGraph.vue'
import DisposisiTerbaru from './components/DisposisiTerbaru.vue'
import RatingBidang from './components/RatingBidang.vue'
import RatingTerbaru from './components/RatingTerbaru.vue'

export default {
  components: {
    PermohonanRecap,
    DisposisiTerbaru,
    RatingBidang,
    RatingTerbaru,
    IzinTerbitGraph,
    PermohonanGraph,
    PermohonanRejectGraph
  },
  data() {
    return {
      yearData: [],
    }
  },
  mounted() {
    this.loadYears()
  },
  methods: {
    async loadYears() {
      const res = await this.$http.get('/dashboard/year-data');
      this.yearData = res.data.data;
    },
  },
}
</script>
